'use client';

import type { JSX } from 'react';
import { Avatar, type AvatarSize } from './Avatar';

export type TeamMemberAvatarMember = {
  firstname?: string | null;
  lastname?: string | null;
  picture?: Array<{ preview_url?: string | null }> | null;
};

export function getTeamMemberFullName(member: TeamMemberAvatarMember): string {
  return `${member.firstname ?? ''} ${member.lastname ?? ''}`.trim();
}

export function getTeamMemberPictureUrl(member: TeamMemberAvatarMember): string | undefined {
  const url = member.picture?.[0]?.preview_url;
  return url ?? undefined;
}

export function TeamMemberAvatar({
  member,
  showName = false,
  size = 'xs',
  className,
}: {
  member: TeamMemberAvatarMember;
  showName?: boolean;
  size?: AvatarSize;
  className?: string;
}): JSX.Element {
  const name = getTeamMemberFullName(member);
  const pictureUrl = getTeamMemberPictureUrl(member);

  return (
    <>
      <Avatar
        pictureUrl={pictureUrl}
        alt={name}
        size={size}
        fallback={name.charAt(0).toUpperCase() || '?'}
        fallbackClassName="bg-gray-200 text-gray-600"
        className={className ?? ''}
      />
      {showName ? <span className="truncate">{name}</span> : null}
    </>
  );
}
